module.exports = __webpack_public_path__ + "static/media/Settigns.75b2cb98.svg";